import { i18n } from '@/i18n';
import { localePrefix } from '@/utils/quran/locale';

/**
 * Public Quran URLs, in the language being read (see locale.js). Trailing
 * slashes are deliberate: the build writes a static page to
 * dist/[bs/]quran/<surah>/<ayah>/index.html and nginx serves it at the slash
 * URL — the canonical one crawlers index.
 */
const base = () => `${localePrefix(i18n.global.locale.value)}/quran`;

export const quranPath = () => `${base()}/`;
export const surahPath = (surah) => `${base()}/${surah}/`;
export const ayahPath = (surah, ayah) => `${base()}/${surah}/${ayah}/`;
export const ayahInSurahPath = (surah, ayah) => `${base()}/${surah}/#ayah-${ayah}`;

export const tafsirPath = (q) => (q ? { path: `${base()}/tafsir/`, query: { q } } : `${base()}/tafsir/`);
export const tafsirSurahPath = (surah, ayah) => `${base()}/tafsir/${surah}/${ayah ? `#ayah-${ayah}` : ''}`;

export const searchPath = (q, extra = {}) => ({ path: `${base()}/search/`, query: { q, ...extra } });
export const rootsPath = (q) => (q ? { path: `${base()}/roots/`, query: { q } } : `${base()}/roots/`);
export const rootPath = (root, lemma) => (lemma ? { path: `${base()}/roots/${root}/`, query: { lemma } } : `${base()}/roots/${root}/`);

export const wordsPath = (q, extra = {}) => ({ path: `${base()}/words/`, query: q ? { q, ...extra } : extra });

/** A path under /quran written without the language ("/quran/2/255/") → in the current one. */
export const localizedQuranPath = (path) => `${localePrefix(i18n.global.locale.value)}${path}`;

export const ayahAnchor = (ayah) => `ayah-${ayah}`;
